const data = {
  allComponents: [
    {
      images: [
        {
          id: '122975192',
          name: 'arrow-left',
          image: {
            alt: 'arrow pointing left',
            id: '47475563',
            url: 'https://www.datocms-assets.com/10154/1659379454-up-arrow-1.svg',
          },
        },
        {
          id: '122975193',
          name: 'arrow-right',
          image: {
            alt: 'arrow pointing right',
            id: '47475566',
            url: 'https://www.datocms-assets.com/10154/1659379496-up-arrow-2.svg',
          },
        },
      ],
    },
  ],
};

export { data };
